<template>
  <div>
    <div class="grid grid-cols-1 gap-2">
      <SelectDefault v-if="readers.length > 0" v-model="reader" :options="readers" option-text="optionText" option-value="optionValue"></SelectDefault>
      <img v-if="img" class="h-20 w-20" :src="img" alt="huella" />
      <div class="actions">
        <ButtonDefault v-if="!capturando" color="blue" @click="capture">Capturar</ButtonDefault>
        <ButtonDefault v-if="capturando" color="red" @click="stopCapture">Detener</ButtonDefault>
        <ButtonDefault v-if="img" color="green" @click="usarHuella">Usar</ButtonDefault>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, inject, onUnmounted } from 'vue'
import {
  FingerprintReader,
  SampleFormat,
  SamplesAcquired
} from '@digitalpersona/devices'
import type { INotificacion, ISelectOption } from '../../interfaces';

const { setFoto } = defineProps<{
  setFoto: (foto: string) => void
}>()
const capturando = ref(false)
const readers = ref<ISelectOption[]>([])
const reader = ref<string | null>(null)
const img = ref<string | null>(null)
const FingerPrint = ref<FingerprintReader | null>(null)
const onCapture = (event: SamplesAcquired) => {
  try {
    const imagen = (event.samples.length > 0 ? `data:image/png;base64,${event.samples[0]}` : null)
    if (imagen) img.value = imagen.replace(/_/g, "/").replace(/-/g, "+")
  } catch (err) {
    console.error('Error al capturar huella:', err)
    window.notificacion.notificacion('failure', 'Error en la captura. Verifica el lector o el agente.')
  }
}
const usarHuella = () => {
  if(img.value) setFoto(img.value)
}
onMounted(async () => {
  try {
    FingerPrint.value = new FingerprintReader()
    FingerPrint.value.on('SamplesAcquired', onCapture)
    await listarReaders()
  } catch (e) {
    console.error('No se pudo conectar al agente DigitalPersona:', e)
    window.notificacion.notificacion('failure', 'Instala o reinicia el DigitalPersona Workstation / Lite Client.')
  }
})

const listarReaders = async () => {
  if(FingerPrint.value){
    const devs = await FingerPrint.value.enumerateDevices()
    readers.value = devs.map(item => ({ optionText: item, optionValue: item }))
    if(devs.length > 0) {
      reader.value = devs[0]
    }
  }
}
async function capture(): Promise<void> {
  if (!reader.value) {
    alert('Selecciona un lector')
    return
  }
  if (capturando.value) return
  await FingerPrint.value?.startAcquisition(SampleFormat.PngImage, reader.value)
  capturando.value = true
}
async function stopCapture(): Promise<void> {
  if (!reader.value) {
    alert('Selecciona un lector')
    return
  }
  if (!capturando.value) return
  await FingerPrint.value?.stopAcquisition(reader.value)
  capturando.value = false
}
onUnmounted(async () => {
  if(capturando.value) await stopCapture()
  if (FingerPrint.value) {
    FingerPrint.value.off('SamplesAcquired', onCapture)
    FingerPrint.value = null
  }
})
</script>
<style scoped>
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
